import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import APIFunction from "../util/api";
import { ERROR_MESSAGES } from "../util/constants";

export default function NotificationBell() {
  const navigate = useNavigate();
  const [hasUnread, setHasUnread] = useState(false);

  useEffect(() => {
    async function fetchUnreadCount() {
      try {
        const response = await APIFunction.getUnreadNotifications()
        setHasUnread(response.count > 0);
      } catch (err) {
        console.error(ERROR_MESSAGES.FAILED_NOTIFICATION, err);
      }
    }

    fetchUnreadCount();
  }, []);

  return (
    <div className="header-icons">
      <span
            className={`header-icon notification ${hasUnread ? "unread" : ""}`}
            onClick={() => navigate("/notifications")} >
            <i className="bi bi-bell"></i>
      </span>
    </div>
  );
}
